/**
 * Shared Google Maps configuration to ensure consistent loading across components
 */

// Define all libraries needed by any map component
export const GOOGLE_MAPS_LIBRARIES = ['places', 'geometry', 'drawing'];

// Export the API key for reuse
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

// Get standard config for useJsApiLoader
export const getGoogleMapsConfig = () => ({
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  libraries: GOOGLE_MAPS_LIBRARIES
});

export default getGoogleMapsConfig;